import { defineMessages } from 'react-intl';

export default defineMessages({
  unknown: 'Unknown',
  other: 'Other',
  deletedGoal: 'Deleted goal',
  yes: 'Yes',
  no: 'No',

  // Device types
  desktop: 'Desktop',
  smartphone: 'Smartphone',
  tablet: 'Tablet',
  'feature phone': 'Feature phone',
  console: 'Console',
  tv: 'TV',
  'car browser': 'Car browser',
  'smart display': 'Smart display',
  camera: 'Camera',
  'portable media player': 'Portable media player',
  phablet: 'Phablet',
  'smart speaker': 'Smart speaker',
  wearable: 'Wearable',
  peripheral: 'Peripheral',

  // Device models
  'generic desktop': 'Generic desktop',
  'generic smartphone': 'Generic smartphone',
  'generic mobile': 'Generic mobile',

  // Referrer types
  direct: 'Direct',
  website: 'Website',
  search: 'Search',
  social: 'Social networks',
  campaign: 'Campaign',
  ai: 'AI assistants',

  reddit: 'Reddit',

  // Visit count grouped
  visitCountGrouped9: '9-14',
  visitCountGrouped15: '15-25',
  visitCountGrouped26: '26-50',
  visitCountGrouped51: '51-100',
  visitCountGrouped101: '101-200',
  visitCountGrouped201: '201+',

  // Days since last visit grouped
  visitDaysSinceLastVisitGrouped8: '8-14',
  visitDaysSinceLastVisitGrouped15: '15-30',
  visitDaysSinceLastVisitGrouped31: '31-60',
  visitDaysSinceLastVisitGrouped61: '61-120',
  visitDaysSinceLastVisitGrouped121: '121-365',
  visitDaysSinceLastVisitGrouped365: '365+',
});
